// Spiegel van api/src/lib/leerlingnummer.js: aparte JS- en TS-packages.
export const LEERLINGNUMMER_MIN = 4;
export const LEERLINGNUMMER_MAX = 32;
export const LEERLINGNUMMER_PATROON = new RegExp(`^[0-9]{${LEERLINGNUMMER_MIN},${LEERLINGNUMMER_MAX}}$`);

export function geldigLeerlingnummer(nummer: unknown) {
  return typeof nummer === 'string' && LEERLINGNUMMER_PATROON.test(nummer);
}
